import { queryString } from 'query-string';

const _isNos = new RegExp('^(http://|https://|//)nos.netease.com/');
const _isNosCdn = new RegExp('^(http://|https://|//)edu-image.nosdn.127.net');
const _isNosMain = new RegExp(
  '^http://nos.netease.com/.*thumbnail=(\\d*)y(\\d*).*',
);
const _isImgph = new RegExp('^(http://|https://|//)img[0-9]*.ph.126.net');
const _isImgMirror = new RegExp(
  '^(http://|https://|//)img-ph-mirror.nosdn.127.net',
);
const _isImgSize = new RegExp('^(http://|https://|//)imgsize.ph.126.net');
const _retUrl = '//imgsize.ph.126.net/?enlarge=true&imgurl=';
const _isBase64 = new RegExp('^data:image/');

const isSupportWebP = (function() {
  let isWebP;
  try {
    isWebP =
      document
        .createElement('canvas')
        .toDataURL('image/webp')
        .indexOf('data:image/webp') == 0;
  } catch (err) {
    isWebP = false;
  }
  return function() {
    return isWebP;
  };
})();

/**
 * 图片转webp格式
 * @param   {String} _url 图片url
 * @returns {String} webp格式的图片url
 * @private
 */
const convertToWebP = _url => {
  let _param;
  let _res;
  let _queryObj;
  let _urlArr;
  let _reg;
  let _suffix;
  // 仅支持nos图片,否则返回
  if (!_isNosCdn.test(_url) && !_isImgMirror.test(_url) && !_isNos.test(_url)) {
    return _url;
  }
  _suffix = _url.substring(_url.lastIndexOf('.'));
  _reg = new RegExp(/^\.gif/);
  // 不支持webp,或者gif类型直接返回
  if (!isSupportWebP() || !!_reg.test(_suffix)) {
    return _url;
  }
  _urlArr = _url.split('?') || [];
  _res = _urlArr[0];
  _param = _urlArr[1] || '';
  _queryObj = queryString.parse(_param, 'object');
  // 原来的链接参数里有imageView,就增加type=webp
  if (_queryObj.imageView != undefined) {
    _res = `${_url}&type=webp`;
  } else {
    _res = `${_url + (_param ? '&' : '?')}imageView&type=webp`;
  }
  return _res;
};

/**
 * 通过相册或者NOS的服务动态缩放图片,走CDN
 * @method scaleImage
 * @param {String} _url 图片地址
 * @param {Number} _width 图片压缩后的宽
 * @param {Number} _height 图片压缩后的高
 * @param {String} _otherProp 附加属性，默认为1x95，可以不传
 * @param {String} _thumbnail 裁剪压缩方式，默认为y，可以不传
 * @param {Boolean} _isWebP  是否转为webp格式,默认false，可以不传
 * 文档链接 http://doc.hz.netease.com/pages/viewpage.action?pageId=68300619
 */
const scaleImage = (_url, _width, _height, _otherProp, _thumbnail, _isWebP) => {
  let _returnUrl;
  let _substr;

  // 让图片走CDN
  function addCDN(_url) {
    // nos的图片，走edu-image.nosdn
    if (_isNos.test(_url)) {
      // 将edu-image的nos图片地址修改为nosdn图片地址,test-edu-image的图片地址保持不变
      var temp_url_arr = _url.split('/');
      if (temp_url_arr[3] == 'edu-image') {
        temp_url_arr[2] = 'edu-image.nosdn.127.net';
        temp_url_arr.splice(3, 1);
        _url = temp_url_arr.join('/');
      }
      // img.ph的图片，走img-ph-mirror.nosdn
    } else if (_isImgph.test(_url)) {
      // 示例http://img1.ph.126.net/elF4TYVICtPUFL-ViqemRg==/6632012246188978210.jpg
      var temp_url_arr = _url.split('/');
      temp_url_arr.splice(0, 3);
      temp_url_arr.unshift('//img-ph-mirror.nosdn.127.net');
      _url = temp_url_arr.join('/');
    }
    return _url;
  }

  // 对图片调用nos图片压缩裁剪服务
  function nosImageView(_url, _width, _height, _otherProp) {
    let sizeStr = '';
    let _suffix;
    let _param;
    let _res;
    let _paramlist;

    if (_width && _height) {
      sizeStr = `&thumbnail=${_width}${_thumbnail || 'y'}${_height}`;
    }
    _res = (_url.split('?') || [])[0];
    _param = _url.split('?')[1] || '';
    // 原来的链接参数里有imageView,就替换掉
    if (!_param || _param.indexOf('imageView') != -1) {
      // 在原来的参数中，只替换thumnail参数，保留其他参数
      _paramlist = _param ? _param.split('&') : [];
      for (let i = 0; i < _paramlist.length; i++) {
        if (
          _paramlist[i].indexOf('thumbnail') != -1 ||
          _paramlist[i].indexOf('imageView') != -1 ||
          _paramlist[i].indexOf('quality') != -1
        ) {
          _paramlist.splice(i, 1);
          i -= 1;
        }
      }

      // thumbnail放最后
      _res = `${_res}?imageView&quality=100${
        _paramlist.length > 0 ? `&${_paramlist.join('&')}` : ''
      }${sizeStr}`;
    } else {
      // 否则把imageView加在后面
      _res = `${_url + (_param ? '&' : '?')}imageView${sizeStr}&quality=100`;
    }

    if (_otherProp) {
      _res += `&${_otherProp}`;
    }
    return _res;
  }

  // 对图片调用相册的裁剪压缩服务
  function phImageView(_url, _width, _height, _otherProp) {
    let _prop;
    let _suffix;
    // 历史遗留相册接口
    _prop = '1x95';
    _suffix = _url.substring(_url.lastIndexOf('.'));

    if (_width && _height) {
      // 传了宽高，进行压缩处理
      // imgurl=后面跟的图片地址不能是https开头的，所有这里强制指定为http:
      _url = `${_retUrl +
        _prefix +
        _url}_${_width}x${_height}x${_prop}${_suffix}`;
    }
    return _url;
  }

  function isNeteaseImg(_url) {
    if (
      _isNosCdn.test(_url) ||
      _isNos.test(_url) ||
      _isImgMirror.test(_url) ||
      _isImgph.test(_url) ||
      _isImgSize.test(_url)
    ) {
      return true;
    }
    return false;
  }

  // 没有图片链接，直接返回
  if (!_url || _isBase64.test(_url) || !isNeteaseImg(_url)) {
    return _url;
  }

  // 干掉所有的http，以及https
  var _prefix = (_url.match(/(\S*)\/\//) || [])[1];
  _url = _url.replace(/^(http:|https:)/, '');

  // imgsize处理过的链接，先取出原图链接
  if (_isImgSize.test(_url)) {
    _substr = _url.match(/imgurl=(\S*)_/);
    _url = _substr[1];
  }

  // 先加上CDN前缀
  _returnUrl = addCDN(_url);

  // gif、svg不压缩处理
  const _suffix = _returnUrl.substring(_returnUrl.lastIndexOf('.'));
  const reg = new RegExp(/(^\.gif|^\.svg)/);
  if (reg.test(_suffix)) {
    return _returnUrl;
  }

  // 再处理缩放参数
  if (_width || _height || _otherProp) {
    // nos cdn或者ph.mirror或者nos的图片，都用nos的imageView裁剪
    if (
      _isNosCdn.test(_returnUrl) ||
      _isImgMirror.test(_returnUrl) ||
      _isNos.test(_returnUrl)
    ) {
      _returnUrl = nosImageView(_returnUrl, _width, _height, _otherProp);
    } else {
      _returnUrl = phImageView(_returnUrl, _width, _height, _otherProp);
    }
  }

  // 转为webp格式图片
  if (_isWebP) {
    _returnUrl = convertToWebP(_returnUrl);
  }
  return _returnUrl;
};

export default { scaleImage };
